module.exports = __webpack_public_path__ + "static/media/ssl commerze.9cd53019.png";